'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _nth2 = require('lodash/nth');
var _nth3 = _interopRequireDefault(_nth2);
var _map2 = require('lodash/map');
var _map3 = _interopRequireDefault(_map2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
var _flatten2 = require('lodash/flatten');
var _flatten3 = _interopRequireDefault(_flatten2);
var _filter2 = require('lodash/filter');
var _filter3 = _interopRequireDefault(_filter2);
var _concat2 = require('lodash/concat');
var _concat3 = _interopRequireDefault(_concat2);
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _lodash = require('lodash.compose');
var _lodash2 = _interopRequireDefault(_lodash);
var _constants = require('../utils/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    computeOptions: function computeOptions(options, data) {
      return (0, _extends3.default)({}, options, {
        axis: (0, _extends3.default)({}, (0, _get3.default)(options, 'axis', {}), {
          linear: (0, _extends3.default)({}, (0, _get3.default)(options, 'axis.linear', {}), {
            pivot: (0, _extends3.default)({}, (0, _get3.default)(options, 'axis.linear.pivot', {}), {
              value: 0
            })
          })
        }),
        serie: (0, _extends3.default)({}, (0, _get3.default)(options, 'serie', {}), {
          annotation: (0, _extends3.default)({}, (0, _get3.default)(options, 'serie.annotation', {}), {
            display: _constants.NEVER
          }),
          stacked: (0, _extends3.default)({}, (0, _get3.default)(options, 'serie.stacked', {}), {
            layerSeries: target.accessors.layerSeries(data)
          })
        })
      });
    },
    /*
      Little trick here, d3.layout.stack only works with y value of a datapoint,
      so here x and y are inverted and reinverted after stack computation.
    */
    layerData: function layerData(dataValidator) {
      return function (data) {
        return (0, _map3.default)(target.accessors.layerSeries(data), function (layer, index) {
          return {
            datapoints: (0, _map3.default)(target.accessors.data(data), function (datapoint) {
              var x = (0, _get3.default)(datapoint, 'x[' + index + ']', 0);
              return (0, _extends3.default)({}, datapoint, {
                y: dataValidator(x) ? x : 0,
                x: datapoint.y,
                formater: (0, _nth3.default)((0, _get3.default)(datapoint, 'formaters', []), index),
                layerIndex: index,
                layerLabel: (0, _get3.default)(layer, 'label', null)
              });
            })
          };
        });
      };
    },
    stackData: function stackData(data) {
      return _d2.default.layout.stack().values(function (d) {
        return d.datapoints;
      }).out(function (d, y0, y) {
        d.y = d.x;
        d.x = y + y0; //needed for computing xDomain
        d.width = y;
        d.x0 = y0;
      })(data);
    },
    nonStackedData: function nonStackedData(data) {
      return (0, _flatten3.default)((0, _map3.default)(data, function (serie) {
        return (0, _get3.default)(serie, 'datapoints', []);
      }));
    },
    // need for axis Labels, see index ...
    stackedNegativeData: function stackedNegativeData(data) {
      return (0, _lodash2.default)(target.computors.stackData, target.computors.layerData(function (d) {
        return d < 0;
      }))(data);
    },
    stackedPositiveData: function stackedPositiveData(data) {
      return (0, _lodash2.default)(target.computors.stackData, target.computors.layerData(function (d) {
        return d > 0;
      }))(data);
    },
    stackedData: function stackedData(data) {
      return (0, _concat3.default)(target.computors.stackedPositiveData(data), target.computors.stackedNegativeData(data));
    },
    data: function data(_data) {
      return (0, _filter3.default)((0, _flatten3.default)((0, _map3.default)(_data, function (serie) {
        return (0, _get3.default)(serie, 'datapoints', []);
      })), function (dp) {
        return dp.width;
      });
    }
    /* 
    even if this data computors is not taken in account in base,
    it doesn't perturb the good data process, but it will be taken in account inside
    bar and will prevent overloading the dom and d3 processes with null bars (minimum the half of the datapoints generated ...)
    */
  });
}
exports.default = computors;